import styled from 'styled-components';

export default styled.div`
	.motif-tab-bar {
		.motif-button {
			border-bottom-width: 0.1rem;
			&:focus {
				outline: none;
			}
		}
	}
	.motif-icon {
		width: var(--px-20);
		height: var(--px-20);
	}
`;
